
window.changeImage = function changeImage(index) {
  const videoUrl = JSON.parse(document.getElementById('data-videos').textContent);
  const largeWebp = JSON.parse(document.getElementById('data-webp1s').textContent);
  const smallWebp = JSON.parse(document.getElementById('data-webp2s').textContent);
  const largeJp2 = JSON.parse(document.getElementById('data-jp21s').textContent);
  const smallJp2 = JSON.parse(document.getElementById('data-jp22s').textContent);
  const largeJpg = JSON.parse(document.getElementById('data-jpg1s').textContent);
  const smallJpg = JSON.parse(document.getElementById('data-jpg2s').textContent);
  const parent = document.getElementById('main-product-image-div');
  const vid = videoUrl[index];
  if (vid !== null) {
    parent.innerHTML = '<video class="img-fluid video" width="863" height="1050" autoPlay playsinline loop muted src="' + encodeURI(vid) + '"></video>';
  } else {
    const webpSrcSet = encodeURI(smallWebp[index]) + ' 1x, ' + encodeURI(largeWebp[index]) + ' 2x';
    const jp2SrcSet = encodeURI(smallJp2[index]) + ' 1x, ' + encodeURI(largeJp2[index]) + ' 2x';
    const jpgSrcSet = encodeURI(smallJpg[index]) + ' 1x, ' + encodeURI(largeJpg[index]) + ' 2x';
    const jpgDirect = encodeURI(smallJpg[index]);
    parent.innerHTML = '<picture> <source type="image/webp" srcset="' +
      webpSrcSet +
      '"> <source type="image/jp2" srcset="' +
      jp2SrcSet +
      '"> <img class="img-fluid" alt="{{ product }}" width="863" height="1050" src="' +
      jpgDirect +
      '" srcset="' +
      jpgSrcSet +
      '"/> </picture>';
  }
  let i = 0;
  for (const e of document.getElementsByClassName('main-product-thumbnail')) {
    if (index === i) e.classList.add('selected'); else e.classList.remove('selected');
    i++;
  }
};

